'use client';

import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import { type PropsWithChildren, useCallback, useState } from 'react';
import type { ReadingKeyModalSchemaT } from '../../../schema/reading-key.schema';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};
export const ReadingKeyModal = (props: PropsWithChildren<ReadingKeyModalSchemaT>) => {
  const {
    openButtonLabel,
    children
  } = props;
  const [open, setOpen] = useState<boolean>(false);
  const handleOpen = useCallback(() => setOpen(true), [setOpen]);
  const handleClose = useCallback(() => setOpen(false), [setOpen]);
  return <>
      <Button onClick={handleOpen} sx={{
      height: '2rem'
    }} data-sentry-element="Button" data-sentry-source-file="reading-key-modal.tsx">
        {openButtonLabel}
      </Button>
      <Modal open={open} onClose={handleClose} closeAfterTransition slots={{
      backdrop: Backdrop
    }} slotProps={{
      backdrop: {
        timeout: 500
      }
    }} data-sentry-element="Modal" data-sentry-source-file="reading-key-modal.tsx">
        <Fade in={open} data-sentry-element="Fade" data-sentry-source-file="reading-key-modal.tsx">
          <Box sx={style} data-sentry-element="Box" data-sentry-source-file="reading-key-modal.tsx">{children}</Box>
        </Fade>
      </Modal>
    </>;
};